import { render, staticRenderFns } from "./Spice.vue?vue&type=template&id=28c74ee4&scoped=true&"
import script from "./Spice.vue?vue&type=script&lang=js&"
export * from "./Spice.vue?vue&type=script&lang=js&"
import style0 from "./Spice.vue?vue&type=style&index=0&id=28c74ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c74ee4",
  null
  
)

export default component.exports